<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>MÜŞTERİ ÇEK KAYIT EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">MÜŞTERİ ÇEK KAYIT EKRANI</a></li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">MÜŞTERİ ÇEK KAYIT EKRANI</h3>

            <div class="tile-body">
              <form>
                <div id="app">
                  <label class="control-label">DEVAMINA YAZILACAK ÇEKİ SEÇİNİZ</label>
                  <select class="form-control" @change="selectCek($event)">
                    <option value="" selected disabled>ÇEK SEÇİNİZ</option>
                    <option v-for="cek in checks" :value="cek.id" :key="cek.id">{{ cek.vade + "~"
                      + cek.firmaname + "~ ÇEK TOPLAMI "
                      + cek.tutar + "₺ ~ KALAN TUTAR "
                      + cek.kalantutar+ "₺" }}</option>
                  </select>
                </div>
                <br>
                <div class="form-group">
                  <label class="control-label">FİRMA ADI :</label>
                  <input v-model="firmaname" class="form-control" type="text"
                    placeholder="FIRMA ADINI KISACA GİRİNİZ" />
                  <br>
                  <label class="control-label">AÇIKLAMA :</label>
                  <input v-model="content" class="form-control" type="text"
                    placeholder="ÇEKLE İLGİLİ SAHA BİLGİSİ GİRİNİZ" />
                  <br>
                  <label class="control-label">BANKA ADI :</label>
                  <input v-model="banka" class="form-control" type="text"
                    placeholder="ÇEKİN HANGİ BANKADAN YAZILDIĞINI GİRİNİZ" />
                  <br>
                  <label class="control-label">ÇEK SERİ NO :</label>
                  <input v-model="serino" class="form-control" type="text"
                    placeholder="ÇEKİN ALTINDA YAZAN ÇEK SERİ NUMARASINI GİRİNİZ" />
                  <br>
                  <label class="control-label">ÇEK TUTARINI GİRİNİZ :</label>
                  <input v-model="tutar" class="form-control" type="number" placeholder="ÇEKİN TUTARINI GİRİNİZ" />
                  <br>
                  <label class="control-label">VADE TARİHİ :</label>
                  <input v-model="vade" class="form-control" type="date" />
                </div>

              </form>
            </div>
            <div class="tile-footer">
              <button @click="sendData()" class="btn btn-success" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Kaydet
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      checks: [],
      operators: [],
      yardimcis: [],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "Cek/getAllCekMainDrop.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.checks = response.data.data;
        console.log(this.checks)
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    selectCek(event) {
      this.maincheck = event.target.value;
      console.log(this.maincheck);
    },

    reload: function () {
      location.reload();
    },
    sendData: function () {
      var url = store.state.base_url + "Cek/createMainCheck.php?key=123";
      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        firmaname: this.firmaname,
        content: this.content,
        banka: this.banka,
        serino: this.serino,
        tutar: this.tutar,
        vade: this.vade,
        maincheck: this.maincheck,
      };

      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          console.log(response)
          if (response.data.data == true) {
            this.$swal({
              text: "Kayıt İşleminiz Başarıyla Gerçekleştirildi!",
              icon: "success",
              closeOnClickOutside: true,
            });
             setTimeout(function () { location.reload() }, 1250);

          } else {
            this.$swal({
              text: "Hata Oluştu!",
              icon: "error",
              closeOnClickOutside: false,
            });
          }

          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });

    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ChecksCariEntry.vue